import React from "react";
import SkeletonWishList from "../SkeletonWishList";

const WishlistSkeleton: React.FC = () => {
  return (
    <div className="relative pt-10 pb-14 ps-14 pe-11 max-xl:py-6 max-xl:pe-8 max-md:p-0">
      <div className="flex items-center justify-between max-sm:me-0 max-lg:me-5 lg:me-9 mb-6 max-md:mb-3">
        <h2 className="text-primary text-2xl max-lg:text-lg max-sm:text-sm whitespace-nowrap flex items-center gap-1">
          Wishlist <div className="skeleton w-6 min-h-6 !rounded-md"></div>
        </h2>
        <div className="flex flex-shrink-0 gap-3 max-lg:gap-2">
          <div className="flex items-center gap-2 max-sm:gap-1 text-xl max-lg:text-base max-sm:text-sm max-[350px]:text-xs">
            <div className="skeleton w-6 min-h-6 !rounded-md"></div>
            <div className="skeleton w-20 min-h-6 !rounded-md"></div>
          </div>

          <div className="flex items-center gap-2 max-sm:gap-1 text-xl max-lg:text-base max-sm:text-sm max-[350px]:text-xs">
            <div className="skeleton w-6 min-h-6 !rounded-md"></div>
            <p className="text-primary-gradient">
              <div className="skeleton w-20 min-h-6 !rounded-md"></div>
            </p>
          </div>
        </div>
      </div>
      <div className="w-full max-md:max-h-full">
        <div className="flex items-center justify-start gap-6 overflow-auto max-md:gap-4 w-full pb-2 mb-2">
          <div className="text-[#89D9EE] text-2xl max-md:text-xl flex-shrink-0 hover:opacity-100 flex items-center gap-1">
            All
            <div className="skeleton w-6 min-h-6 !rounded-md"></div>
          </div>
          <div className="text-[#89D9EE] text-2xl max-md:text-xl flex-shrink-0 hover:opacity-100 flex items-center gap-1">
            Episodes
            <div className="skeleton w-6 min-h-6 !rounded-md"></div>
          </div>
          <div className="text-[#89D9EE] text-2xl max-md:text-xl flex-shrink-0 hover:opacity-100 flex items-center gap-1">
            Music
            <div className="skeleton w-6 min-h-6 !rounded-md"></div>
          </div>
        </div>

        <div className="max-h-[600px] overflow-auto mb-12 max-sm:mb-0 max-md:max-h-full grid max-md:gap-3 pe-3">
          <SkeletonWishList />
        </div>
      </div>
    </div>
  );
};

export default WishlistSkeleton;
